import React from "react";
import CommonButton from "../../CommonButton";

export interface PromoCardProps {
    badgeText: string;
    badgeClassName: string;
    title: React.ReactNode; // Allows using <br /> inside the title
    description: string;
    descriptionClassName?: string;
    buttonText: string;
    buttonClassName: string;
    onButtonClick?: () => void;
    imageSrc: string;
    imageAlt: string;
    cardClassName: string;
}

const PromoCard: React.FC<PromoCardProps> = ({
    badgeText,
    badgeClassName,
    title,
    description,
    descriptionClassName = "text-gray-500", // default fallback
    buttonText,
    buttonClassName,
    onButtonClick,
    imageSrc,
    imageAlt,
    cardClassName,
}) => {
    return (
        <div className={`p-5 md:p-10 rounded-[3rem] border relative overflow-hidden group ${cardClassName}`}>
            <div className="relative z-10">
                <span className={`text-[10px] font-black px-3 py-1 rounded-full uppercase ${badgeClassName}`}>
                    {badgeText}
                </span>

                <h3 className="text-xl md:text-3xl font-black text-logoHeading mt-4">
                    {title}
                </h3>

                <p className={`mt-4 mb-8 text-sm md:text-lg ${descriptionClassName}`}>
                    {description}
                </p>

                <CommonButton
                    text={buttonText}
                    className={`border-none rounded-xl px-8 ${buttonClassName}`}
                    onClick={onButtonClick}
                />
            </div>

            <img
                src={imageSrc}
                alt={imageAlt}
                className="absolute -bottom-10 -right-4 w-56 opacity-40 group-hover:scale-110 transition-transform duration-700"
            />
        </div>
    );
};

export default PromoCard;